import { UploadService } from 'service/usecases/upload-service'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'
import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestSurgicalPresignedUrlDecorator } from 'main/decorators/prepare-api-request-surgical-presigned-url-decorator/prepare-api-request-surgical-presigned-url-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import { ApiRepository } from 'repository/api-repository'

export const makeUploadService = (
  surgicalOrderRepository: SurgicalOrderRepository
): UploadService => {
  const presignedUrlRepository = new SurgicalOrderRepository(
    new PrepareApiRequestSurgicalPresignedUrlDecorator(
      makeLocalStorageAdapter(),
      new ApiRepository(new ApiClientImplementation())
    )
  )

  return new UploadService(
    (params) => presignedUrlRepository.requestPresignedUrl(params),
    (params) => surgicalOrderRepository.notifyDocumentProcessing(params)
  )
}
